// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"365":"68291f1f","978":"2fb44355"}[chunkId] + ".js";
};